/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Json_Rest_Api_S5_Li1Inputs */

const en_guide_json_rest_api_s5_li1 = /** @type {(inputs: Guide_Json_Rest_Api_S5_Li1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use <strong>camelCase</strong> for JSON property names (most common convention)`)
};

const ko_guide_json_rest_api_s5_li1 = /** @type {(inputs: Guide_Json_Rest_Api_S5_Li1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON 속성 이름에 <strong>camelCase</strong>를 사용하세요 (가장 일반적인 규칙)`)
};

const ja_guide_json_rest_api_s5_li1 = /** @type {(inputs: Guide_Json_Rest_Api_S5_Li1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSONプロパティ名には<strong>camelCase</strong>を使用してください（最も一般的な規約）`)
};

/**
* | output |
* | --- |
* | "Use <strong>camelCase</strong> for JSON property names (most common convention)" |
*
* @param {Guide_Json_Rest_Api_S5_Li1Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_json_rest_api_s5_li1 = /** @type {((inputs?: Guide_Json_Rest_Api_S5_Li1Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Json_Rest_Api_S5_Li1Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_json_rest_api_s5_li1(inputs)
	if (locale === "ko") return ko_guide_json_rest_api_s5_li1(inputs)
	return ja_guide_json_rest_api_s5_li1(inputs)
});